export const STICKY_CARD_BG_IMG_PATH =
  '/blog-post-get-started-cta-bg-image.png';
export const STICKY_CARD_BG_IMG_WEBP_PATH =
  '/blog-post-get-started-cta-bg-image.webp';
export const EXIT_INTENT_MODAL_BG_IMG_PATH =
  '/blog-post-get-started-popup-bg-image.png';
export const EXIT_INTENT_MODAL_BG_IMG_WEBP_PATH =
  '/blog-post-get-started-popup-bg-image.webp';
export const YOUTUBE_PLAY_ICON = '/icons/youtube-play.svg';
